<template>
  <div id="topnavbar" class="is-marginless is-paddingless">
    <div class="container top-navigation is-hidden-mobile">
      <nav
        class="is-flex is-justify-content-space-between is-mobile is-align-items-baseline"
      >
        <div class="column column-left">
          <ul>
            <li id="gov-link-anchor">
              <a
                :href="siteSeplagLink"
                target="_blank"
                :aria-label="Home.TopNavigationBar.ARIA.ACCESS_SEPLAG"
                rel="noopener external"
              >
                {{ siteSeplag }}
              </a>
            </li>
            <li>
              <a
                :href="governmentPortalLink"
                target="_blank"
                :aria-label="Home.TopNavigationBar.ARIA.ACCESS_GOV"
                rel="noopener external"
              >
                {{ governmentPortal }}
              </a>
            </li>
          </ul>
        </div>

        <div class="column accessibility">
          <span class="mr-15">{{ accessibility }}</span>
          <ul>
            <b-tooltip
              :label="Home.TopNavigationBar.HIGH_CONTRAST_LABEL"
              :type="isContrast ? 'is-white' : 'is-blue-oil'"
              size="is-small"
              position="is-bottom"
            >
              <li class="cursor-pointer">
                <img
                  :src="
                    isContrast
                      ? require('@/assets/svg/Iv_contrast.svg')
                      : require('@/assets/svg/Iv.svg')
                  "
                  alt=""
                  :aria-label="Home.TopNavigationBar.ARIA.CHANGE_HIGH_CONTRASTE"
                  role="button"
                  @click="darkModeSwitch()"
                />
              </li>
            </b-tooltip>
            <b-tooltip
              :label="Home.TopNavigationBar.REDUCE_SIZE"
              :type="isContrast ? 'is-white' : 'is-blue-oil'"
              size="is-small"
              position="is-bottom"
            >
              <li
                class="cursor-pointer"
                :class="{
                  'config-selected': getUserConfig.fontSize === 'minor'
                }"
              >
                <img
                  :src="
                    isContrast
                      ? require('@/assets/svg/Am_contrast.svg')
                      : require('@/assets/svg/Am.svg')
                  "
                  alt=""
                  aria-label="Diminuir o tamanho do texto"
                  role="button"
                  @click="changeFontSize('minor')"
                />
              </li>
            </b-tooltip>
            <b-tooltip
              :label="Home.TopNavigationBar.NORMAL_SIZE"
              :type="isContrast ? 'is-white' : 'is-blue-oil'"
              size="is-small"
              position="is-bottom"
            >
              <li
                class="cursor-pointer"
                :class="{
                  'config-selected': getUserConfig.fontSize === 'normal'
                }"
              >
                <img
                  :src="
                    isContrast
                      ? require('@/assets/svg/A_contrast.svg')
                      : require('@/assets/svg/A.svg')
                  "
                  alt=""
                  :aria-label="Home.TopNavigationBar.ARIA.REDEFINE_TEXT_SIZE"
                  role="button"
                  @click="changeFontSize('normal')"
                />
              </li>
            </b-tooltip>
            <b-tooltip
              :label="Home.TopNavigationBar.INCREASE_SIZE"
              :type="isContrast ? 'is-white' : 'is-blue-oil'"
              size="is-small"
              position="is-bottom"
            >
              <li
                class="cursor-pointer"
                :class="{
                  'config-selected': getUserConfig.fontSize === 'plus'
                }"
              >
                <img
                  :src="
                    isContrast
                      ? require('@/assets/svg/Ap_contrast.svg')
                      : require('@/assets/svg/Ap.svg')
                  "
                  alt=""
                  :aria-label="Home.TopNavigationBar.ARIA.INCREASE_TEXT_SIZE"
                  role="button"
                  @click="changeFontSize('plus')"
                />
              </li>
            </b-tooltip>
          </ul>
        </div>
      </nav>
    </div>

    <div v-if="!isHome" class="is-vcentered navigation has-background-color-7">
      <section class="menu-header container pb-5 has-background-color-7">
        <img
          class="govern-project-logo py-5 pl-20"
          :alt="Home.TopNavigationBar.ALT.GOV_SEPLAG"
          :src="isContrast ? govSuiteLogoContrast : govSuiteLogo"
          @click="goToHomePage"
        />
        <SimpleNavigation class="pr-20" />
      </section>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import SimpleNavigation from "@/components/SimpleNavigation";
import { Home } from "@/utils/constants";
import govSuiteLogo from "@/assets/images/APP_HEADER_LOGO.png";
import govSuiteLogoHome from "@/assets/images/HOME_LOGO.png";
import govSuiteLogoContrastHome from "@/assets/images/HOME_LOGO_contrast.png";
import govSuiteLogoContrast from "@/assets/images/APP_HEADER_LOGO_contrast.png";

export default {
  name: "TopNavigationBar",
  components: {
    SimpleNavigation
  },
  data() {
    return {
      Home,
      accessibility: Home.ACCESSIBILITY,
      siteSeplag: Home.SEPLAG_SITE_LABEL,
      siteSeplagDs: Home.SEPLAG_SITE_DS,
      siteSeplagLink: Home.SEPLAG_SITE_LINK,
      governmentPortal: Home.GOVERNMENT_PORTAL.toUpperCase(),
      governmentPortalLink: Home.GOVERNMENT_PORTAL_LINK,
      governmentPortalDs: Home.GOVERNMENT_PORTAL,
      darkMode: false,
      govSuiteLogo,
      govSuiteLogoHome,
      govSuiteLogoContrast,
      govSuiteLogoContrastHome
    };
  },
  computed: {
    ...mapGetters({ getUserConfig: "getUserConfig", isContrast: "isContrast" }),
    isHome() {
      return this.$router.currentRoute.path === "/";
    },
    logo() {
      let imgName = "govSuiteLogo";
      if (this.isContrast) imgName += "Contrast";
      if (this.isHome) imgName += "Home";
      return this[imgName];
    }
  },
  mounted() {
    const config = JSON.parse(localStorage.getItem("PERSON_CONFIG"));
    config && this.setConfig(config);
    this.darkMode = this.isContrast;
  },
  methods: {
    ...mapMutations({ setConfig: "setConfig" }),

    darkModeSwitch() {
      this.darkMode = !this.darkMode;
      this.setConfig({
        ...this.getUserConfig,
        theme: this.darkMode ? "dark" : "light"
      });
    },
    changeFontSize(size) {
      this.setConfig({ ...this.getUserConfig, fontSize: size });
    },
    goToHomePage() {
      this.$router.replace("/");
    }
  }
};
</script>

<style scoped lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/variables";
#topnavbar {
  background-color: var(--color-2);
  color: var(--color-8);
  border-bottom: 10px solid #80c470;
  min-height: 65px;
  width: auto;

  #gov-link-anchor::after {
    content: "|";
  }

  .accessibility {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    ul {
      display: flex;
      gap: 5px;
    }
  }
}

.container {
  padding: 10px 0 0 0;

  @media screen and (max-width: $tablet-low) {
    padding: 10px 5px 0 5px;
  }

  @media screen and (max-width: $desktop) {
    margin: 0 30px;
  }
}

.top-navigation {
  max-width: none !important;
  width: 90vw;
  padding: 0 32px !important;
}

#topnavbar .column.column-left > ul {
  margin-top: 5px;
}

#topnavbar .column.column-left > ul li {
  display: inline-block;
  margin: 0 2px;
}

#topnavbar .column.column-left > ul li > a {
  background-color: transparent !important;
  color: var(--dynamic-title-color);
  font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
  font-size: 0.8rem;
  font-weight: 500;

  &:hover,
  &:focus {
    text-decoration: underline;
  }

  &:active {
    text-decoration: underline;
  }
}

.config-selected {
  color: $primary;
}

.dark-button {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  overflow: hidden;
  border: 1px solid var(--dynamic-title-color);
  background-color: transparent;

  div {
    width: 7px;
    height: 15px;
    background-color: var(--dynamic-title-color);
  }
}
</style>
